var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildings1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/buildings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.6,
    d: "M50.5499 20C50.1499 21.5 50 23.15 50 25V40H25V30C25 24.5 29.5 20 35 20H50.5499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50 95V40H25C15 40 10 45 10 55V95C10 105 15 110 25 110H65C55 110 50 105 50 95ZM33.75 85C33.75 87.05 32.05 88.75 30 88.75C27.95 88.75 26.25 87.05 26.25 85V65C26.25 62.95 27.95 61.25 30 61.25C32.05 61.25 33.75 62.95 33.75 65V85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M70 110H65C55 110 50 105 50 95V25C50 15 55 10 65 10H95C105 10 110 15 110 25V95C110 105 105 110 95 110H90",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M90 90V110H70V90C70 87.25 72.25 85 75 85H85C87.75 85 90 87.25 90 90Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70 68.75C67.95 68.75 66.25 67.05 66.25 65V40C66.25 37.95 67.95 36.25 70 36.25C72.05 36.25 73.75 37.95 73.75 40V65C73.75 67.05 72.05 68.75 70 68.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M90 68.75C87.95 68.75 86.25 67.05 86.25 65V40C86.25 37.95 87.95 36.25 90 36.25C92.05 36.25 93.75 37.95 93.75 40V65C93.75 67.05 92.05 68.75 90 68.75Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings1);
export default __webpack_public_path__ + "static/media/buildings-1.6faa762bf793ace62c5226f1880cd1f4.svg";
export { ForwardRef as ReactComponent };